var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0v-6h-8v6a1 1 0 1 1-2 0V5a1 1 0 0 1 2 0v6h8V5a1 1 0 0 1 1-1M18.5 10a3 3 0 0 1 3 3v.214c0 .91-.387 1.78-1.064 2.388l-2.605 2.345-.057.053H20.5a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1v-.593c.003-.302.028-.65.173-.975l.08-.157c.203-.351.512-.609.74-.814l2.605-2.345c.256-.23.402-.558.402-.902V13a1 1 0 1 0-2 0v.4a1 1 0 0 1-2 0V13a3 3 0 0 1 3-3"
  })));
};
export default Svg24;